
import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href="https://facebook.com/newwavesgroup" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://instagram.com/newwavesgroup" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://wa.me/2348175961899" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>
        <div className="footer-section">
          <h4>Subsidiaries</h4>
          <ul>
            <li><a href="/ict-hub">New Wave ICT Hub Limited</a></li>
            <li><a href="/projects">New Wave Projects Limited</a></li>
            <li><a href="/estate">New Wave Estate & Properties Development Limited</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>House 5 No 51 Oba Akinloye Street<br />Oral Estate Lekki Lagos Nigeria</p>
          <p>Tel: +234(803)5399398</p>
          <p>Email: newwave@thenewwavesgroup.com</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; 2024 The New Waves Group Limited®️. All rights reserved. |
          <a href="https://www.jidemobell.dev" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'underline', marginLeft: 8, marginRight: 8 }}>
            Crafted by Jidemobell
          </a>
          |
          <a href="https://www.atensai.com" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'underline', marginLeft: 8 }}>
            Built under Atensai
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
